<template>
  <modal
    name="defaultOfficeSelection-modal"
    :width="'100%'"
    :adaptive="true"
    :height="'auto'"
    :max-width="700"
    :clickToClose="false"
    :scrollable="true"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="container modal--container">
      <div class="d-flex flex-wrap justify-content-between mb-2">
        <h1>{{ "Select default office" }}</h1>
      </div>

      <div class="d-flex flex-column flex-wrap">
        <span>
          You have been added to
          {{
            filteredEmployees.length > 0 &&
              filteredEmployees[0].attributes.organization_name
          }}
          hungerhub account. Please ensure you are ordering under the correct
          account when placing your order. To change office profiles, select
          your name in the top right corner. To remove an office from your
          account, visit your profile page or start a chat. Which account would
          you like to login to now
        </span>

        <div
          v-if="employee && filteredEmployees.length >= 1"
          class="d-flex flex-column mt-3"
        >
          <button
            v-for="(emp, index) in filteredEmployees"
            :key="emp.id"
            :class="{
              'dropdown-item pl-0': true,
              'office-button-pad': index > 0
            }"
            @click="setOrganization(emp)"
          >
            <span class="text-left">{{
              emp && emp.attributes.organization_name
            }}</span>
          </button>
          <hr />
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { updateUserProfile } from "../utils/api";
import { mapGetters, mapState } from "vuex";

export default {
  name: "DefaultOfficeSelectionModal",
  props: { height: { default: "auto" } },
  computed: {
    ...mapState(["employee", "currentOrganization"]),
    ...mapGetters(["getFirstEmployeeId", "getFirstLocation"]),
    filteredEmployees() {
      let filtered = this.employee.employees.filter(
        emp =>
          emp.attributes.organization_type == "Location" &&
          emp.attributes.organization_active &&
          !emp.attributes.soft_deleted &&
          emp.attributes.uncatering &&
          emp?.attributes?.active
      );

      return filtered.length >= 1 ? filtered : [];
    }
  },
  data() {
    return {};
  },
  methods: {
    beforeOpen(event) {
      // let self = this;
      // if (event.params.body !== undefined && event.params.body.length)
      //   this.body = event.params.body;
      // if (event.params.subtext !== undefined && event.params.subtext.length)
      //   this.subtext = event.params.subtext;
      // if (event.params.order !== undefined) {
      //   this.orderDetails = event.params.order;
      //   this.orderItems = event.params.order.order_items;
      //   this.eta = event.params.eta;
      //   // this.setTaxCode();
      // }
    },
    beforeClose(e) {
      clearInterval(this.etaTimer);
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide("defaultOfficeSelection-modal");
      document.body.classList.toggle("noscroll");
    },
    setOrganization(org) {
      let params = {
        user: {
          employees_attributes: {
            id: org.id,
            default: true
          }
        }
      };

      updateUserProfile(params, org.id).then(response => {
        if (response && response.data && response.data.attributes) {
          this.$store.commit("SET_ORGANIZATION", org);
          this.$store.dispatch("FETCH_LOCATION");
          this.$store.commit("UPDATE_TIP", "0");
          this.$store.commit("UPDATE_TIP_OFFICE_ADMIN", "0");
          this.$store.commit("SET_SHOW_DEFAULT_OFFICE_SELECTION", false);

          this.$router.replace(this.$route.query.from || "/restaurants");
          this.closeModal();

          setTimeout(() => location.reload(), 1500);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 20px;
  font-weight: 500;
  color: #393838;
  width: 80%;
  margin: 0;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

span {
  font-size: 14px;
  font-weight: normal;
  color: #393838;
}

.caption {
  font-size: 13px;
  font-weight: normal;
  color: #393838;
}

p {
  color: #393838;
}

.modal__btn {
  border-radius: 9px;
  background-color: #6d69d3;
  color: #fff;
  font-weight: 500;
  border: none;
  padding: 8px 20px;
}

.modal--container {
  padding: 20px 30px 30px 30px;
  overflow-y: auto;
  max-height: 750px;
  height: 100%;
}

.close {
  color: #000000;
}

.close-text {
  font-size: 24px;
}

@media (max-width: 767px) {
  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 12px;
    margin-bottom: 2px;
  }

  span {
    font-size: 13px;
  }

  p {
    font-size: 11px;
  }

  .caption {
    font-size: 11px;
  }

  td {
    font-size: 11px;
  }

  .modal__btn {
    border-radius: 4px;
    font-weight: 500;
    border: none;
    font-size: 11px;
    padding: 4px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultOfficeSelectionModal.vue